import React, { useState, useReducer } from 'react';
import { useIntl } from 'umi';
import { Segment } from 'tea-component';
import StatsComp from './index';
import StatsComps from '../StatsPC/index';
import classnames from 'classnames';
import { IAction, IStatsFilter } from '../../typings';
import './index.scss';

const reducer = (state: IStatsFilter, { type, payload }: IAction) => ({
  ...state,
  [type]: payload,
});

export default function Comp(props: any) {
  const { genreSource, entityType, pcGameSegmentClassName, bySegmentClassName, genreType } = props;
  const [leftSegment, setLeftSegment] = useState(entityType);
  const [rightSegment, setRightSegment] = useState('operation');
  const [destroyed, setDestroyed] = useState(false);

  const isMarketSegmentHide = leftSegment === 'mobile' && genreSource === 'annie';
  const { formatMessage } = useIntl();
  const handleDestroyed = () => {
    setDestroyed(true);
    setTimeout(() => {
      setDestroyed(false);
    }, 0);
  };

  const [filter, filterDispatch] = useReducer(reducer, {
    marketType: leftSegment,
    dimension: rightSegment,
    regions: ['global'],
    markets: ['global'],
    startDate: '',
    endDate: '',
    granularity: 'monthly',
    dataSourceSingle: {
      value: 'sensortower',
    },
  });

  const [loading, loadingDispatch] = useReducer(reducer, {
    table: false,
    lineChart: false,
  });

  return (
    <div className="dbi-genre-tabdetails--stats dbi-genre-tabdetails--statsg">
      <div className="dbi-genre-segment">
        {!isMarketSegmentHide && (
          <Segment
            className="segment-light dbi-segment-right"
            value={leftSegment}
            onChange={(value: string) => {
              filterDispatch({ type: 'marketType', payload: value });
              handleDestroyed();
              setLeftSegment(value);
            }}
            options={[
              {
                text: formatMessage({ id: 'dbi_market_mobile' }),
                value: 'mobile',
              },
              {
                text: formatMessage({ id: 'dbi_market_pc' }),
                value: 'pc',
                className: pcGameSegmentClassName,
              },
              {
                text: formatMessage({ id: 'dbi_market_console' }),
                value: 'console',
              },
            ]}
          />
        )}
        <Segment
          className={classnames('segment-light', bySegmentClassName)}
          value={rightSegment}
          disabled={loading.table && loading.lineChart}
          onChange={(value: string) => {
            filterDispatch({ type: 'dimension', payload: value });
            handleDestroyed();
            setRightSegment(value);
          }}
          options={[
            {
              text: formatMessage({ id: 'dbi_market_operation_data' }),
              value: 'operation',
            },
            {
              text: formatMessage({ id: 'dbi_market_by_game' }),
              value: 'games',
            },
            {
              text: formatMessage({ id: 'dbi_genre_profile_by_countries' }),
              value: 'countries',
            },
            {
              text: formatMessage({ id: 'dbi_market_by_companies' }),
              value: 'companies',
            },
          ]}
        />
      </div>

      {destroyed ? null : leftSegment === 'mobile' ? (
        <>
          <StatsComp
            {...props}
            leftSegment={leftSegment}
            rightSegment={rightSegment}
            destroyed={destroyed}
            filter={filter}
            filterDispatch={filterDispatch}
            isMarketSegmentHide={isMarketSegmentHide}
            genreSource={genreSource}
            genreType={genreType}
            loading={loading}
            loadingDispatch={loadingDispatch}
          />
        </>
      ) : (
        <StatsComps
          {...props}
          leftSegment={leftSegment}
          rightSegment={rightSegment}
          destroyed={destroyed}
          filter={filter}
          filterDispatch={filterDispatch}
          isMarketSegmentHide={isMarketSegmentHide}
          genreSource={genreSource}
          genreType={genreType}
        />
      )}
    </div>
  );
}
